import { Button } from '@saleswhale/barnacle/components';
import { Link } from 'react-router-dom';
import SixSenseLogoWithSlogan from '../../../../assets/icons/6s-logo-with-slogan.svg';
import ErrorEtPng from '../../../../assets/images/6s-error-et.png';
import styles from './404.module.scss';

export default function PageDoesNotExist() {
  return (
    <div className={styles.Container} data-testid="PageDoesNotExist">
      <img alt="Error E.T graphic" className={styles.ErrorEtImg} src={ErrorEtPng} />
      <div className={styles.GridContainer}>
        <img
          alt="Six Sense Logo with slogan"
          className={styles.Logo}
          src={SixSenseLogoWithSlogan}
        />
        <h3 className={styles.Heading}>404 Error</h3>
        <p className={styles.JediMindTrick}>This is not the page you are looking for.</p>
        <Link to="/">
          <Button>Home</Button>
        </Link>
      </div>
    </div>
  );
}
